var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertChartOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 11.3333H4.66675V6.66667H6.00008V11.3333ZM8.66675 11.3333H7.33341V4.66667H8.66675V11.3333ZM11.3334 11.3333H10.0001V8.66667H11.3334V11.3333ZM13.0001 12.7333H3.00008V3.33333H13.0001V12.7333ZM13.0001 2H3.00008C2.26675 2 1.66675 2.6 1.66675 3.33333V12.6667C1.66675 13.4 2.26675 14 3.00008 14H13.0001C13.7334 14 14.3334 13.4 14.3334 12.6667V3.33333C14.3334 2.6 13.7334 2 13.0001 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChartOutlined);
export default __webpack_public_path__ + "static/media/insert-chart-outlined.0c7d421bae8ac640e6c72629f0203661.svg";
export { ForwardRef as ReactComponent };